import { Language } from './types';

export const LANGUAGES = Object.values(Language);
export const FORCE_LANGUAGE = 'sb-force-language';
